import React, { Fragment, useContext, useEffect, useState } from 'react'
import Tip from 'app/React/Components/misc/Tip'
import { validateSteps } from 'app/React/Helpers/StepHelper'
import TradeFields from "app/React/Components/Form/TradeFields";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function TradePaymentRadio(props) {
  const {
    currentVariant,
    endpoints,
    isDealerConfigurator,
    isStorageOrderHandled,
    order,
    restNonce,
    setOrder,
    strings,
    setValidSteps
  } = useContext(ConfiguratorContext)

  const name = 'trade'

  const payment_strings = strings.payment_form ?? {}
  const [visibleChildren, setVisibleChildren] = useState(order[name] === 'yes')

  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState(null)

  const useDisplayGuaranteePrice = () => Boolean(Number(currentVariant.steps?.[5]?.show_guarantee_price ?? '0'))

  const initial_value = typeof order[name] !== 'undefined' ? order[name] : ''
  const options = [
    {
      label: payment_strings.trade.yes,
      value: 'yes'
    },
    {
      label: payment_strings.trade.no,
      value: 'no'
    }
  ]

  const onchange = async function (value) {
    setMessage(null)

    order[name] = value

    if (value === 'no') {
      order.trade_plate = ''
      order.trade_km = ''
      order.guarantee_price = null
      order.guarantee_price_car = null
      order.guarantee_price_outstanding_debt = null
    }

    setOrder({ ...order })
    setValidSteps(validateSteps(currentVariant.steps, order, isDealerConfigurator, currentVariant))
    setVisibleChildren(value === 'yes')
  }

  const onEnvInputBlur = (e) => {
    setMessage(null)

    if (e.target.value === '') {
      order.guarantee_price = null
      order.guarantee_price_car = null
      order.guarantee_price_outstanding_debt = null

      setOrder({ ...order })
    } else {
      const tradePlate = e.target.name === 'trade_plate' ? e.target.value : order.trade_plate
      const tradeKm = e.target.name === 'trade_km' ? e.target.value : order.trade_km

      checkGuaranteePrice(tradePlate, tradeKm)
    }
  }

  const fetchGuaranteePrice = async (tradePlate, tradeKm) => {
    if (typeof tradePlate !== 'string' || tradePlate.length < 1 || typeof tradeKm !== 'string' || tradeKm.length < 1) {
      setLoading(false)
      return
    }

    await fetch(
      endpoints.guarantee_price,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': restNonce
        },
        body: JSON.stringify({
          tradePlate: tradePlate,
          tradeKm: tradeKm
        })
      }
    )
      .then(async response => {
        setLoading(false)

        if (response.status === 200) {
          const body = await response.json()

          order.guarantee_price = body.info.price
          order.guarantee_price_car = body.info.car

          setOrder({ ...order })

          setMessage(payment_strings.guarantee_price?.successful)
        } else {
          setMessage(payment_strings.guarantee_price?.unsuccessful)
        }

        return true
      })
      .catch(error => {
        setLoading(false)
        setMessage(payment_strings.guarantee_price?.unsuccessful)

        return false
      })
  }

  const checkGuaranteePrice = (tradePlate, tradeKm) => {
    setLoading(true)

    order.guarantee_price = null
    order.guarantee_price_car = null

    setOrder({ ...order })

    fetchGuaranteePrice(tradePlate, tradeKm)

    return true
  }

  // const checkGuaranteePrice = useMemo(() => {
  //   return debounce((tradePlate, tradeKm) => {
  //     setLoading(true)
  //
  //     Env.set('order.guarantee_price', null)
  //     Env.set('order.guarantee_price_car', null)
  //     storageSet(identifier, 'order', Env.get('order'))
  //
  //     fetchGuaranteePrice(tradePlate, tradeKm)
  //
  //     return true
  //   }, 2000)
  // }, [])

  useEffect(() => {
    if (!useDisplayGuaranteePrice() || isStorageOrderHandled !== true) {
      return
    }

    checkGuaranteePrice(order.trade_plate, order.trade_km)
  }, [isStorageOrderHandled])

  useEffect(() => {
    setVisibleChildren(order[name] === 'yes')
  }, [order[name]])

  if (order.paymentType === 'leasing' && !useDisplayGuaranteePrice()) {
    return null
  }

  return (
    <>
      <h2 className='config-form__subtitle'>
        {payment_strings?.trade.label}
        {typeof payment_strings?.trade.tip === 'string' && payment_strings?.trade.tip.length > 0 ?
          <Tip content={payment_strings?.trade.tip}/> : null}
      </h2>
      {typeof payment_strings.guarantee_price.notice === 'string' && payment_strings.guarantee_price.notice.length > 0 ? (
        <div className='description'>{payment_strings.guarantee_price.notice}</div>
      ) : null}
      <div className='config-radio'>
        {
          options.map((key, index) => (
            <Fragment key={index}>
              <input
                onChange={async () => await onchange(options[index].value)}
                type='radio'
                name={name}
                id={['paymentradio_', name, options[index].value].join('_')}
                value={options[index].value}
                checked={initial_value === options[index].value}
              />
              <label
                htmlFor={['paymentradio_', name, options[index].value].join('_')}
                className='config-radio__radio'
                layout='standard'
              >
                {options[index].label}
                <div className='description'>{options[index].description}</div>
              </label>
            </Fragment>
          ))
        }
      </div>
      {
        visibleChildren
          ? <TradeFields
            displayGuaranteePrice={useDisplayGuaranteePrice()}
            loading={loading}
            onEnvInputBlur={useDisplayGuaranteePrice() ? onEnvInputBlur : () => {
            }}
            message={message}
          />
          : null
      }
      <div className='config-form__separator'/>
    </>
  )
}
